import { connect } from "react-redux";
import { Badge, Layout, Tabs } from "antd";
import { useState, useEffect, useRef } from "react";

import VideoTranscript from "./Transcript/VideoTranscript";
import QuizQuestionsContainer from "./QuizQuestions/QuizQuestionsContainer";
import ChatbotContainer from "./CubitsGPT/ChatbotContainer.js";
import PromotionTab from "./Promotion/PromotionTab.js";
import {
    ArrowLeftOutlined
} from "@ant-design/icons";

const { TabPane } = Tabs;

const VideoPageFeatureMenu = ({
    collapsedTranscript,
    currentTimestamp,
    pauseVideo,
    quizQuestions,
    seekOnTranscriptClick,
    seekToVideoTimestamp,
    singleCollection,
    singleVideo,
    currentUser,
    isAuthenticated,
    moduleAccess
}) => {
    const [sidebarWidth, setSidebarWidth] = useState(() => {
        const saved = localStorage.getItem('cugpt-sidebar-width');
        return saved || '30vw';
    });
    const [isResizing, setIsResizing] = useState(false);
    const sidebarRef = useRef(null);
    const isResizingRef = useRef(false);
    const currentWidthRef = useRef(sidebarWidth);

    const pendingQuestions = () => {
        /*let count = 0;
        quizQuestions.forEach(question => {
            if(currentTimestamp >= question.endVideoTimestamp && question.latestAttempt == null){
                count += 1
                return 
            }else{
                return
            }
        })
        return count*/
        return quizQuestions.length;
    };

    useEffect(() => {
        if (isResizing) {
            isResizingRef.current = true;
            document.body.style.cursor = 'col-resize';
            document.body.style.userSelect = 'none';
        } else {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        }

        // Cleanup: ensure body styles are reset on unmount
        return () => {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
    }, [isResizing]);

    useEffect(() => {
        currentWidthRef.current = sidebarWidth;
    }, [sidebarWidth]);

    const handleResizeStart = (e) => {
        e.preventDefault();
        setIsResizing(true);
    };

    return (
        <>
            {isResizing && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 9998,
                        cursor: 'col-resize',
                        pointerEvents: 'auto'
                    }}
                    onMouseMove={(e) => {
                        if (!isResizingRef.current) return;
                        const viewportWidth = window.innerWidth;
                        const newWidthPx = viewportWidth - e.clientX;
                        const newWidthVw = (newWidthPx / viewportWidth) * 100;
                        const constrainedWidth = Math.max(20, Math.min(50, newWidthVw));
                        const newWidth = `${constrainedWidth}vw`;
                        currentWidthRef.current = newWidth;
                        setSidebarWidth(newWidth);
                    }}
                    onMouseUp={() => {
                        if (isResizingRef.current) {
                            isResizingRef.current = false;
                            setIsResizing(false);
                            localStorage.setItem('cugpt-sidebar-width', currentWidthRef.current);
                            document.body.style.cursor = '';
                            document.body.style.userSelect = '';
                        }
                    }}
                />
            )}
            <div style={{ position: 'relative', display: 'flex', height: '100%' }} ref={sidebarRef}>
                {!collapsedTranscript && (
                    <div
                        className="sidebar-resize-handle"
                        onMouseDown={handleResizeStart}
                        style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: '4px',
                            cursor: 'col-resize',
                            zIndex: 1000,
                            backgroundColor: 'transparent',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            if (!isResizing) {
                                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!isResizing) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }
                        }}
                    />
                )}
            <Layout.Sider
                className={collapsedTranscript ? "" : "visible-transcript-sider"}
                width={sidebarWidth}
                collapsedWidth={0}
                collapsible
                collapsed={collapsedTranscript}
                trigger={null}>
            <Tabs
                defaultActiveKey={
                    singleCollection?.promotions?.length > 0 // Promotions
                        ? "4"
                        : singleCollection?.defaultTab === 1 // Transcript
                            ? "1" : singleCollection?.defaultTab === 2 // Questions
                                ? "2" : singleCollection?.defaultTab === 3 || (singleCollection?.gptEnabled && singleVideo) // cuGPT
                                    ? "3"
                                    : "1" // Transcript
                }
                id="transcript-tab-container">
                <TabPane
                    tab={
                        <Badge size="small" count={0}>
                            <div style={{ padding: "6px 3px 0px 0px" }}>
                                Transcript
                            </div>
                        </Badge>
                    }
                    key="1"
                    className="transcript-tab">
                    <div id="transcript-tab-content">
                        <VideoTranscript
                            seekOnTranscriptClick={seekOnTranscriptClick}
                        />
                    </div>
                </TabPane>

                <TabPane
                    forceRender
                    tab={
                        <Badge size="small" count={pendingQuestions()}>
                            <div style={{ padding: "6px 3px 0px 0px" }}>
                                Questions
                            </div>
                        </Badge>
                    }
                    key="2"
                    className="transcript-tab">
                    <div id="transcript-tab-content">
                        <QuizQuestionsContainer
                            pauseVideo={pauseVideo}
                            quizQuestions={quizQuestions}
                            seekToVideoTimestamp={seekToVideoTimestamp}
                        />
                    </div>
                </TabPane>

                {singleCollection?.gptEnabled &&
                    singleVideo &&
                    singleCollection && (
                        <TabPane
                            tab={
                                <span>
                                    <span className="cu-gpt-badge">cuGPT</span>
                                    <span className="cu-gpt-badge-ask-me"> <ArrowLeftOutlined />Ask me</span>
                                </span>
                            }
                            key="3"
                            className="cugpt-tab">
                            <div id="cugpt-tab-content">
                                <ChatbotContainer
                                    video={singleVideo}
                                    collection={singleCollection}
                                    pauseVideo={pauseVideo}
                                    isCollectionOwner={
                                        singleCollection &&
                                        currentUser &&
                                        singleCollection.primaryAuthor?.id ===
                                        currentUser.id
                                    }
                                />
                            </div>
                        </TabPane>
                    )}

                {singleCollection?.promotions?.length > 0 && (
                    <TabPane
                        tab={
                            <Badge size="small" count={0}>
                                <div className="promo-gradient-btn animation-btn">
                                    Promoted Courses
                                </div>
                            </Badge>
                        }
                        style={{ marginLeft: "auto" }}
                        key="4"
                        className="promotion-tab">
                        <div id="promotion-tab-content">
                            <PromotionTab
                                promotions={singleCollection.promotions}
                                isAuthenticated={isAuthenticated}
                                moduleAccess={moduleAccess}></PromotionTab>
                        </div>
                    </TabPane>
                )}
            </Tabs>
            </Layout.Sider>
        </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        currentTimestamp: state.videoControlReducer.videoTimestamp,
        quizQuestions: state.collectionReducer.quizQuestions,
        singleCollection: state.collectionReducer.singleCollection,
        singleVideo: state.collectionReducer.singleVideo,
        currentUser: state.userReducer.user,
        isAuthenticated: state.userReducer.isAuthenticated,
        moduleAccess: state.collectionReducer.singleCollectionAccess
    };
};

export default connect(mapStateToProps)(VideoPageFeatureMenu);
